import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getShippingDateInitialSetting } from "../../../http/api/MasterAPI";

const ShippingDateInitialSettingSelect = ({ value, error, onChangeValue }) => {
  const [listShippingDateInitialSettingSelect, setListShippingDateInitialSettingSelect] = useState([]);
  
  async function getShippingDateInitialSettingSelect() {
    try {
      const response = await getShippingDateInitialSetting();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          shippingDateInitialSettingCd: element.varCd,
          shippingDateInitialSettingName: element.varValue1,
        }))
        .filter(
          (x) => x.shippingDateInitialSettingName && x.shippingDateInitialSettingName.trim() !== ""
        );
      setListShippingDateInitialSettingSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getShippingDateInitialSettingSelect();
  }, []);

  
  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("shippingDateInitialSettingCd")}

      >
        {listShippingDateInitialSettingSelect.map((item) => (
          <MenuItem
            key={"shippingDateInitialSetting" + item.shippingDateInitialSettingCd}
            value={item.shippingDateInitialSettingCd}
          >
            {item.shippingDateInitialSettingName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0}}>{error}</FormHelperText>
      )}
     </FormControl>
    
  );
};

export default ShippingDateInitialSettingSelect;
